import cacheLs from "../cacheLs"

export default {
  addEventStatus (state, data) {
    state.selectedEventStatus = { ...data }
    cacheLs.set_event_status(data)
  }
}
